module.exports = __webpack_public_path__ + "static/media/flag.41f2fa47.svg";